import { gameState, TechId } from "./gameState";

export type TechDefinition = {
  id: TechId;
  name: string;
  description: string;
  cost: number;
  minLevel: number; // Minimum level required to unlock
};

// SORTED: Cheapest -> Most Expensive
export const TECH_TREE: TechDefinition[] = [
  // --- TIER 1: MAP 1 (River Valley) ---
  {
    id: "efficiency_1",
    name: "High-Pressure Nozzle",
    description: "Scrubber cleans pollution 50% faster.",
    cost: 50,
    minLevel: 0 // Available from Map 1
  },
  {
    id: "radius_1",
    name: "Wide-Angle Spray",
    description: "Increases brush size by +1 (approx 50% larger).",
    cost: 150,
    minLevel: 0 // Available from Map 1
  },

  // --- TIER 2: MAP 2 (Arid Wasteland) ---
  {
    id: "capacity_1",
    name: "Reserve Tank",
    description: "Doubles maximum spray energy to 200%.",
    cost: 300,
    minLevel: 1 // Unlocked at Map 2
  },
  {
    id: "regen_1",
    name: "Solar Capacitor",
    description: "Spray energy recharges 3x faster.",
    cost: 500,
    minLevel: 1 // Unlocked at Map 2
  },

  // --- TIER 3: MAP 3 (Ancient Forest) ---
  {
    id: "radius_2",
    name: "Industrial Sprayer",
    description: "Maximizes brush size (Adds +2 radius).",
    cost: 800,
    minLevel: 2 // Unlocked at Map 3
  },
  {
    id: "seeding_1",
    name: "Bio-Seed Injection",
    description: "Scrubbing barren land instantly plants grass (20% chance).",
    cost: 1200,
    minLevel: 2 // Unlocked at Map 3
  }
];

export function purchaseTech(techId: TechId): boolean {
  const tech = TECH_TREE.find(t => t.id === techId);
  if (!tech) return false;

  if (gameState.biomass >= tech.cost && !gameState.unlockedTechs.includes(techId)) {
    gameState.biomass -= tech.cost;
    gameState.unlockedTechs.push(techId);
    return true;
  }
  return false;
}

export function hasTech(techId: TechId): boolean {
  return gameState.unlockedTechs.includes(techId);
}